
export default function (context, error) {
    if(!error) return;
    console.log(error);
    if (error.response) {
        switch (error.response.status) {
            case 0:
                return;
            case 401:
                if (DEV) {
                    context.commit('user/clean');
                    context.commit('user/events/clean');
                    context.commit('user/permit/clean');
                    context.commit('user/setting/clean');
                    return;
                }
                window.location.href = '/tourclient/login.html?ret='+encodeURIComponent(window.location.href);
                return;
            default: {
                window.app.$notify.error({
                    title: 'Ошибка',
                    message: 'Не удалось получить данные с сервера'
                });
            }
        }
    }
}